import React from 'react';
import './footer.css'; // Ensure this file exists for styling
import logo from "../assets/logo_relison(1).jpg";
import facebookIcon from "../assets/icons8-facebook-24.png";
import twitterIcon from "../assets/icons8-x-50.png";
import pinterestIcon from "../assets/icons8-pinterest-30.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Information */}
        <div className="footer-section company-info">
          <img
            src={logo}
            alt="Company Logo"
            className="footer-logo"
          />
          <p>
          Established in 2014, Our company is committed to marketing, supplying, and trading a wide range of high-quality pharmaceutical medicines. 
          With a focus on reliability and excellence, it ensures products meet the highest standards of safety and effectiveness.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Corporate Office */}
        <div className="footer-section corporate-office">
          <h4>Corporate Office</h4>
          <p>
            <b>Address:</b> Relison Pharma, 503-B, Priviera Nehrunagar Circle, Near Bank of Baroda, Ahmedabad - 380015
          </p>
          <p>
            <b>Email:</b> relisonpharma@gmail.com
          </p>
          <p>
            <b>Phone:</b> +91 9411015885
          </p>
        </div>

        {/* Follow Us */}
        <div className="footer-section social-links">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><img src={facebookIcon} alt="Facebook" /></a>
            <a href="#"><img src={twitterIcon} alt="Twitter" /></a>
            <a href="#"><img src={pinterestIcon} alt="Pinterest" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
